/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import Switch from '@mui/material/Switch';

function CheckCost({ parent, callback }) {
  const [check, setCheck] = useState(false);

  useEffect(() => {
    setCheck(parent.checklist === 'Y');
  }, [parent]);

  return (
    <Switch
      checked={check}
      onChange={(e) => {
        setCheck(e.target.checked);
        callback({
          id: parent.id,
          checklist: e.target.checked ? 'Y' : 'N',
        });
      }}
      inputProps={{ 'aria-label': 'controlled' }}
      color='info'
    />
  );
}

CheckCost.propTypes = {
  parent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    checklist: PropTypes.string.isRequired,
  }).isRequired,
  callback: PropTypes.func.isRequired,
};

export default CheckCost;
